module.exports = {
  "country": "NO",
  "artist": "Morland & Debrah Scarlett",
  "song": "A Monster Like Me",
  "year": "2015",
  "place": "8",
  "spotify": "4MRQLR8LmFTaBTMQzcoXgJ"
};